module.exports = __webpack_public_path__ + "static/media/unread.6407dda5.svg";